import Line from "libs/preact-chart/Bar";
import ChartCard from "components/Chart/ChartCard";

var options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  tooltips: {
    enabled: false,
  },
};

function LineChart({ name, data, getReport }) {
  const dataSet = [
    {
      label: data.label_item,
      tension: 0.1,
      data: data.values,
      fill: false,
      borderColor: "rgb(75, 192, 192)",
      pointRadius: 4,
      pointHoverRadius: 6,
      borderWidth: 2,
    },
  ];

  if (data.max_value) {
    options.scales = {
      y: {
        min: data.min_value,
        max: data.max_value,
      },
    };
  }

  const refName = "line-chart-presik";
  return (
    <ChartCard
      header={name}
      header_meta={data.header_meta}
      desc={data.desc}
      desc_meta={data.desc_meta}
      getReport={getReport}
    >
      <Line
        height={350}
        options={options}
        refName={refName}
        labels={data.labels}
        dataSet={dataSet}
      />
    </ChartCard>
  );
}

export default LineChart;
